import { render, staticRenderFns } from "./XmTable.vue?vue&type=template&id=19d508ea&scoped=true"
import script from "./XmTable.vue?vue&type=script&lang=js"
export * from "./XmTable.vue?vue&type=script&lang=js"
import style0 from "./XmTable.vue?vue&type=style&index=0&id=19d508ea&prod&lang=css"
import style1 from "./XmTable.vue?vue&type=style&index=1&id=19d508ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d508ea",
  null
  
)

export default component.exports